export class Controller {

    /** @ngInject */
    constructor($state, SharedFolderAddCSAModal, SharedFolderAddNoteModal) {
        this.$state = $state;
        this.SharedFolderAddCSAModal = SharedFolderAddCSAModal;
        this.SharedFolderAddNoteModal = SharedFolderAddNoteModal;
    }

    $onInit() {
        
    }

    showAddButtons() {
        return this.$state.current.name === 'company.sharing-center.shared-folders.manage.edit';
    }

    addPasswordManager() {
        this.SharedFolderAddCSAModal(false, this.sharedFolder, this.items)
        .then(() => this.$state.reload('company.sharing-center.shared-folders'));
    }

    addAuthenticator() {
        this.SharedFolderAddCSAModal(true, this.sharedFolder, this.items)
        .then(() => this.$state.reload('company.sharing-center.shared-folders'));
    }

    addNote() {
        this.SharedFolderAddNoteModal(this.sharedFolder, this.items)
        .then(() => this.$state.reload('company.sharing-center.shared-folders'));
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/manage-shared-folder.controller.js